<div class="background-image">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h3 class="display-4">Welcome to the NLR Reports Repository</h3>
        </div>
      </div>
      <p class="lead">Royal NLR conducts research, which is published in reports. Only a minor part of these reports is made public. This repository holds these public, so called Technical Publications (TP), mainly produced from 1996 up till now.</p> 
      <p>Technical publications published before 1996 may be obtained using the <a href="https://reports.nlr.nl/info/feedback">request-form</a>. Other types of NLR-reports are Contract Reports (CR) and Technical Reports (TR), which in general are not public. You may however request a copy by using the <a href="https://reports.nlr.nl/info/feedback">request-form</a>. In some cases permission may be granted, depending on specific properties and contractor of the report. Reports will be supplied as pdf-file.</p>
    </div>
  </div>
  <small class="credits">Photo by <a href="https://www.nlr.nl/">NLR</a></small>
</div>
